import { EventEmitter, inject } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { distinctUntilChanged } from 'rxjs';
import { GenericTimeSlot } from '../../models';

/** when extending this class be sure to implement ngOnInit,
 * @Input()
 * override set isDisabled(isDisabled: boolean) {
 *   if (isDisabled) {
 *     this.form.disable();
 *     this.toolTip = 'Select day frist';
 *   } else {
 *     this.form.enable();
 *     this.toolTip = '';
 *   }
 * }
 * 
 * @Input()
 * override set timeSlots(timeSlots: GenericTimeSlot[]) {
 *   this._timeSlots = timeSlots;
 *   this.form.reset();
 * }
 * 
 * @Input()
 *  override set selectedTime(timeSlot: GenericTimeSlot) {
 *    if (timeSlot) {
 *      this.form.patchValue({ timeSlot });
 *    }
 *  }
 *
 * @Output()
 * override onTimeChange = new EventEmitter<TimePickerForm>();
 */
export abstract class NgxAimTimePickerClass {
  // ngOnInit() {
  //   this.init();
  // }

  fb = inject(FormBuilder);

  set isDisabled(isDisabled: boolean) {
    if (isDisabled) {
      this.form.disable();
      this.toolTip = 'Select day frist';
    } else {
      this.form.enable();
      this.toolTip = '';
    }
  }

  set timeSlots(timeSlots: GenericTimeSlot[]) {
    this._timeSlots = timeSlots;
    this.form.reset();
  }

  set selectedTime(timeSlot: GenericTimeSlot) {
    if (timeSlot) {
      this.form.patchValue({ timeSlot });
    }
  }

  _timeSlots: GenericTimeSlot[] = [];

  onTimeChange!: EventEmitter<GenericTimeSlot>;

  form = this.fb.group({
    timeSlot: this.fb.control<GenericTimeSlot | null>(null, { validators: [Validators.required] }),
  });

  changes$ = this.form.valueChanges.pipe(
    distinctUntilChanged(),
    takeUntilDestroyed(),
  );

  toolTip = '';

  init() {
    this.changes$.subscribe(() => {
      if (this.form.valid) {
        this.emitData();
      }
    });
  }

  emitData() {
    if (this.form.controls.timeSlot.value) {
      this.onTimeChange.next(this.form.controls.timeSlot.value);
    }
  }
}
